import { useState, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { ConfigProvider } from 'antd'

import { colors } from '../../services/styles'
import api from '../../services/api'

import Approval from './components/Approval'

import '../../routes/components/layouts/ExternalLayout.css'
import { displayMessage } from '../../helpers/messages'
import { EPublicApprovalScreenParams } from '../../enums/EPublicApprovalScreenParams'
import { SL_PublicLayout } from '../../components/publicLayout/PublicLayout'

export const PublicApprovals = ({ isApproval }) => {
    const [showComponent, setShowComponent] = useState(false)
    const [errorMessage, setErrorMessage] = useState(null)

    let [searchParams, setSearchParams] = useSearchParams()
    const token = searchParams.get(EPublicApprovalScreenParams.TOKEN)

    const getApproval = async () => {
        try {
            const { data } = await api.approvals.getApproval(token)
            if (data.error) {
                setErrorMessage(data.error_message)
                setShowComponent(false)
            } else {
                setShowComponent(true)
                setErrorMessage(null)
            }
        } catch (err) {
            setErrorMessage(displayMessage('PUBLIC_RAE_ERROR_MESSAGE'))
        }
    }

    useEffect(() => {
        getApproval()
    }, [])

    return (
        <SL_PublicLayout>
            <ConfigProvider
                theme={{
                    token: {
                        colorError: colors['sl-red'][600],
                    },
                }}
            >
                <div className="flex flex-col items-center flex-1 p-5">
                    {showComponent && <Approval isApproval={isApproval} token={token} onRecharge={() => getApproval()} />}
                    {errorMessage && <span className="text-center font-bold text-xl text-white">{errorMessage}</span>}
                </div>
            </ConfigProvider>
        </SL_PublicLayout>
    )
}
